import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { redirect } from '../lib/utils/browser';
import { getRedirectUrl } from '../lib/successUrlHelper';


const ReturnToTimberlandButtonComponent = () => (
    <button
        type="button"
        className="sid-btn"
        aria-label="submit"
        onClick={() => redirect(getRedirectUrl())}
        onKeyPress={() => redirect(getRedirectUrl())}
        tabIndex={0}
    >
        <FormattedHTMLMessage id="step.error.redirectButtonText" defaultMessage="CONTINUE TO TIMBERLAND" />
    </button>
);

export { ReturnToTimberlandButtonComponent };
